import { render, staticRenderFns } from "./listsalerservice.vue?vue&type=template&id=748f6f1c&"
import script from "./listsalerservice.vue?vue&type=script&lang=js&"
export * from "./listsalerservice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports